import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";

type ClockIconProps = Partial<SVGIconProps>;

const ClockIcon = (props: ClockIconProps) => {
  return (
    <SVGIcon viewBox="0 0 15 14" {...props}>
      <path
        d="M7.49984 7.00002H6.99984C6.99984 7.21524 7.13755 7.4063 7.34172 7.47436L7.49984 7.00002ZM7.99984 4.08335C7.99984 3.80721 7.77598 3.58335 7.49984 3.58335C7.22369 3.58335 6.99984 3.80721 6.99984 4.08335H7.99984ZM9.09172 8.05769C9.35369 8.14502 9.63685 8.00344 9.72418 7.74147C9.8115 7.4795 9.66992 7.19634 9.40795 7.10901L9.09172 8.05769ZM7.99984 7.00002V4.08335H6.99984V7.00002H7.99984ZM7.34172 7.47436L9.09172 8.05769L9.40795 7.10901L7.65795 6.52568L7.34172 7.47436ZM12.8332 7.00002C12.8332 9.94554 10.4454 12.3334 7.49984 12.3334V13.3334C10.9976 13.3334 13.8332 10.4978 13.8332 7.00002H12.8332ZM7.49984 12.3334C4.55432 12.3334 2.1665 9.94554 2.1665 7.00002H1.1665C1.1665 10.4978 4.00203 13.3334 7.49984 13.3334V12.3334ZM2.1665 7.00002C2.1665 4.0545 4.55432 1.66669 7.49984 1.66669V0.666687C4.00203 0.666687 1.1665 3.50222 1.1665 7.00002H2.1665ZM7.49984 1.66669C10.4454 1.66669 12.8332 4.0545 12.8332 7.00002H13.8332C13.8332 3.50222 10.9976 0.666687 7.49984 0.666687V1.66669Z"
        fill="currentColor"
      />
    </SVGIcon>
  );
};

export default ClockIcon;
